var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownArrow = function SvgDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0 4 5 0 0h8Z",
    fill: "#fff"
  })));
};
export { SvgDownArrow as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='8' height='5' viewBox='0 0 8 5' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M8 0L4 5L0 0H8Z' fill='white'/%3E %3C/svg%3E";